export { default as InfoTable } from './table'
export type { Props as InfoTableProps, Config as InfoTableConfig } from './table'

export { default as InfoBlock } from './block'
